import { calculateGridTemplateColumns } from 'components/DesignSystems/FilterHeader/calculateGridTemplateColumns';

const ResourceSectionTableHeader = () => {
  const gridTemplateColumns = calculateGridTemplateColumns(5);
  return (
    <div className="filter-card-header" style={{ gridTemplateColumns }}>
      <div>{''}</div>
      <div>Resource</div>
      <div>Leader</div>
      <div># of Persons</div>
      <div>Contact Info</div>
      <div>Reporting Info / Notes</div>
      <div>{''}</div>
    </div>
  );
};

export default ResourceSectionTableHeader;
